var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.devices),function(device){return _c(device.type,{key:device.id,tag:"component",attrs:{"device":device}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }